import React from "react";
import PropTypes from "prop-types";

/**
 * Component for conditionally rendering children
 *
 * Why conditionally render like this?
 * 1. Keeping js out of jsx for better stratified architecture
 *    see: https://superpedestrian.atlassian.net/l/c/1cwNum0D
 * 2. People constantly mess up conditional display in jsx
 *    see: https://kentcdodds.com/blog/use-ternaries-rather-than-and-and-in-jsx/
 * 3. Extendability. At some future date could theoretically add behavior
 *    like animating removal, logging, or other such nonsense
 *
 */

const If = React.forwardRef(({ children, condition, ...props }, ref) => {
  if (ref)
    return condition ? React.cloneElement(React.Children.only(children), { ref }) : props.else;
  return condition ? children : props.else;
});

If.propTypes = {
  children: PropTypes.node.isRequired,
  condition: PropTypes.any,
  else: PropTypes.node,
};

If.defaultProps = {
  condition: null,
  else: null,
};

export default React.memo(If);
